export const READER_LOAD_PURCHASED_BOOKS = '@reader/purchased-books';
export const READER_SET_CURRENT_BOOK = '@reader/current-book';
export const READER_SET_READER_URL = '@reader/set-reader-url';
